// extracted by mini-css-extract-plugin
module.exports = {"newContent":"styles_newContent__2Fwwl","form":"styles_form__3BCAT"};